import React from 'react'
import './ImageBanner.css'
import Button from '../Button/Button'

const ImageBanner = () => {
  return (
    <div className = 'ImageBanner'>
        <Button text = 'Go Back Home' path= '/' />
    </div>
  )
}

export default ImageBanner